
import moment from "moment";
import { intl } from "LocaleWrapper";
import { useStoreState } from "ezStore";
import { useQuery } from "@apollo/client";
import { Table } from "@cofano/cck";
import { DataFormat } from "imports/Utils";
import { SearchInvoicesDocument, type SearchInvoicesQuery } from "__generated__/view/invoices/graphql/invoices.queries.generated";
import { SortDirection } from "__generated__/enums";
import { ChildPropsFromPagination } from "types/commons";

type InvoiceFromQuery = ChildPropsFromPagination<SearchInvoicesQuery, "searchInvoices">;

interface PreviousInvoicesTableProps {
	creditor: {
		id: number;
	};
	debtor: {
		id: number;
	};
}

const PreviousInvoicesTable = ({ creditor, debtor }: PreviousInvoicesTableProps) => {

	const session = useStoreState(store => store.session);

	const { data, loading } = useQuery(SearchInvoicesDocument, {
		variables: {
			search: {
				creditors: [ creditor.id ],
				debtors: [ debtor.id ],
			},
			pagination: {
				page: 0,
				size: 10,
				sortList: [ {
					field: "date",
					direction: SortDirection.Desc,
				} ],
			},
		},
	});

	const invoices = data?.searchInvoices?.content ?? [];

	return (
		<Table
			id="invoices_new_previous_invoices"
			disableFooter={true}
			contentLoading={loading}
			content={invoices}
			columns={[ {
				id: "date",
				title: intl.formatMessage({ id: "INVOICE_DATE" }),
				render: (row: InvoiceFromQuery) => row.date ? moment(row.date).format("ll") : "",
			}, {
				id: "totalAmount",
				title: intl.formatMessage({ id: "AMOUNT" }),
				render: (row: InvoiceFromQuery) => DataFormat.price(row.totalAmount ?? 0, row.currency?.isoCode || undefined, session.locale),
			} ]} />
	);
};

export default PreviousInvoicesTable;
